import { IEventRequestParams } from './shared.dto';

abstract class IPassportUrlRedirectionDAO {
    public abstract getPassportUrlRedirection(params: IEventRequestParams): Promise<IPassportUrlRedirectionDTO>;
    public abstract updatePassportUrlRedirection(params: IEventRequestParams & IPassportUrlRedirectionDTO): Promise<IPassportUrlRedirectionDTO>;
}

interface IPassportUrlRedirectionDTO {
    urlRedirectionEnabled: boolean;
    redirectUrl: string;
}

export { IPassportUrlRedirectionDAO, IPassportUrlRedirectionDTO };
